import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import agencyApi from "api/agencyApi";

export const getAgencyCampaignList = createAsyncThunk(
  "AgencyPrepayment",
  async (params: any = {}) => {
    try {
      const response = await agencyApi.agencyPrepaymentList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getPrepaymentDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await agencyApi.getAgencyPrepaymentDetail(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postPrepayment = async (data: any = {}) => {
  try{
    const response = await agencyApi.createAgencyPrepayment(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putPrepayment = async (id: string | number , data: any = {}) => {
  try{
    const response = await agencyApi.updateAgencyPrepayment(id, data);
    return response;
  }catch (error) {
    return error;
  }
};